import classNames from "classnames";
import { PropsWithChildren } from "react";

import styles from "./ContentWrapper.module.scss";

export type PaddingConfig = {
  paddingTop?: number;
  paddingBottom?: number;
  paddingRight?: number;
  paddingLeft?: number;
};

type ContentWrapperProps = React.HtmlHTMLAttributes<HTMLDivElement> & {
  padding?: number;
  paddingConfig?: PaddingConfig;
  borderRadius?: number;
  className?: string;
};

const DEFAULT_PADDING_CONFIG: PaddingConfig = {
  paddingTop: 0,
  paddingLeft: 0,
  paddingRight: 0,
  paddingBottom: 0,
};

export const ContentWrapper = (
  props: PropsWithChildren<ContentWrapperProps>
): JSX.Element => {
  const {
    padding,
    paddingConfig = DEFAULT_PADDING_CONFIG,
    children,
    borderRadius,
    className,
    ...rest
  } = props;

  if (typeof padding !== "undefined") {
    return (
      <div
        style={{
          padding: padding,
          borderRadius: borderRadius,
        }}
        className={classNames(className, styles.contentWrapper)}
        {...rest}
      >
        {children}
      </div>
    );
  }

  return (
    <div
      className={classNames(className, styles.contentWrapper)}
      style={{
        paddingTop: paddingConfig.paddingTop,
        paddingBottom: paddingConfig.paddingBottom,
        paddingRight: paddingConfig.paddingRight,
        paddingLeft: paddingConfig.paddingLeft,
        borderRadius: borderRadius,
      }}
      {...rest}
    >
      {children}
    </div>
  );
};
